import { z } from 'zod';

export const thinkToolInputSchema = z.object({
    thought: z.string().describe('A thought to think about.'),
});

export type ThinkToolInput = z.infer<typeof thinkToolInputSchema>;

export const thinkToolOutputSchema = z.object({
    thought: z.string(),
});

export type ThinkToolOutput = z.infer<typeof thinkToolOutputSchema>;

export const thinkToolSignature = {
    name: 'think',
    description:
        'Use the tool to think about something. It will not obtain new information or change any data, but just append the thought to the context. Use it when complex reasoning or some working memory is needed, especially for analyzing tool outputs, verifying compliance with policies, or planning multi-step actions.',
    inputSchema: thinkToolInputSchema,
    outputSchema: thinkToolOutputSchema,
};
